<span class="cursor-pointer" (click)="goBack()"><i
       class="fa fa-chevron-left left_chevron-copy-4 mt-4 mb-4"></i> Back</span>
<div class="container mt-5">
  <div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
  <div class="rk-ui-notification" *ngIf="notificationAlert" style="z-index: 10000;">
    <span id="notificationMessageText">{{product_notify_message}}</span>
    <a class="close rk-linknotification" (click)="notificationAlert=false">×</a>
  </div>
  
  <section id="default" class="padding-top0">
    <div class="row">
      <div class="col-md-6">
        <div class="xzoom-container">
          <div
            class="zoomer img-zoom-container"
            (mouseenter)="imageZoom('img-lg-zoom', 'myresult')"
            (mouseleave)="removeHover('myresult')"
          >
            <img
              class="xzoom"
              id="img-lg-zoom"
              src="{{ baseUrl + '/' + medium_image }}"
              onError="this.src = 'assets/v3/img/noImg.png' "
            />
          </div>
          <div
            id="myresult"
            class="img-zoom-result"
            style="display: none"
          ></div>

          <div
            id="carouselExample"
            class="xzoom-thumbs carousel slide"
            data-ride="carousel"
            data-interval="9000"
          >
            <div
              class="carousel-inner row w-100 mx-auto xzoom-thumbs"
              role="listbox"
            >
              <div
                class="carousel-item col-md-3 mt-3"
                *ngFor="let item of product_detail.images; let i = index"
                [class.active]="selectedIndex === i"
              >
                <img
                  class="img-fluid mx-auto d-block xzoom-gallery"
                  src="{{ baseUrl + '/' + item }}"
                  alt="slide 2"
                  onerror="this.src='./assets/img/no_image.svg'"
                  style="width: 100px"
                  (click)="sendMidImge(item, i)"
                  [class.active]="selectedIndexChange === i"
                />
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselExample"
              role="button"
              data-slide="prev"
            >
              <span
                ><i class="fa fa-angle-left" style="margin-left: -37px"></i
              ></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next text-faded"
              href="#carouselExample"
              role="button"
              data-slide="next"
            >
              <span><i class="fa fa-angle-right"></i></span>
              <span class="sr-only">Previous</span>
            </a>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-pos">
          <div class="mb-1">
            <!-- Catalogue breadcrumb -->
            <small
              class="Living-room-seating cursor-pointer"
              (mouseover)="$event.target.style.color = '#922230'"
              (click)="goBack()"
              >Catalogue</small
            >

            <!-- segment breadcrumb -->
            <i class="fa fa-angle-right cosTogg1"></i
            ><small
              class="Sofa-Sets cursor-pointer"
              (mouseover)="$event.target.style.color = '#922230'"
              (click)="goBack()"
              >Curtains</small
            >

            <!-- category breadcrumb -->

            <!-- product breadcrumb -->
            <i class="fa fa-angle-right cosTogg1"></i
            ><small class="Hopefull-Sofa cursor-pointer">{{
              product_detail.product
            }}</small>
          </div>
          <div class="sku-chng">
            <small class="SKU-Code-Arr-2Seat">
              SKU Code :{{ product_detail.unique_sku }}</small
            >
          </div>
          <div class="coc">
            <h4 class="Coco---Two-Seater-So">
              {{ product_detail.product }}
              <!-- <i class="fa {{product_detail.liked ? 'fa-heart' : 'fa-heart-o'}} pull-right mx-2"
                          style="color:#8c051e;font-size: 26px;" (click)="likeProduct(product_detail.id)"></i> -->
              <!-- <i class="fa fa-heart Path_110"></i> -->
            </h4>
          </div>
          
          <div class="coc">
            <!-- <span class="colr_label">Master Option</span> -->
            <div class="row">
              <div class="col-9">
                <div class="master_option">
                  <div class="mb-3">
                    <span>Height (in cm):<span class="astric">*</span></span>
                    <span><input type="number" class="height_class" [(ngModel)]="height_value" (blur)="onBlurMethod()"/></span>
                  </div>
                  <div class="ml-1">
                    <span>Width (in cm):<span class="astric">*</span></span>
                    <span><input type="number" class="height_class" [(ngModel)]="width_value" (blur)="onBlurMethod()"/></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="coc">
            <span class="colr_label">Lining Fabric</span>
            <div class="row">
              <div class="col-9">
                <select class="select_class" (change)="changeFabricHandler($event.target.value)">
                  <option value="" selected>Select Option</option>
                  <option *ngFor="let cm of fabricList" value="{{ cm.id }}" [selected]="cm.id == this.selectedFabric">
                    {{ cm.display_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="coc">
            <span class="colr_label">Hardware</span>
            <div class="row">
              <div class="col-9">
                <select class="select_class" (change)="changeHardwareHandler($event.target.value)">
                  <option value="" selected>Select Option</option>
                  <option *ngFor="let item of hardwareList" value="{{ item.id }}"
                      [selected]="item.id == this.selectedHardware">{{item.display_name}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="coc">
            <span class="colr_label">Variation</span>
            <div class="row">
              <div class="col-9">
                <select class="select_class" (change)="changeVariantsHandler($event.target.value)">
                  <option value="" selected>Select Option</option>
                  <option *ngFor="let item of variationList" value="{{ item.id }}"
                    [selected]="item.id == this.counts">{{item.display_name}}</option>
                </select>
              </div>
            </div>
          </div>

          <ng-container *ngIf="show_price">
          <div class="coc mt-4">
            <div class="row">
              <div class="col-9">
                <span style="font-weight: bold; font-style: italic;">₹ {{ final_price | number: '1.2-2'}}</span>
              </div>
            </div>
          </div>
          </ng-container>

          <div class="coc mt-4" *ngIf="(window.location.pathname !=='/catalogue')">
            <div class="row">
              <div class="col-6">
                <span>Quantity:<span class="astric">*</span></span>
                <span>
                  <input 
                    type="number" 
                    class="height_class"
                    [(ngModel)]="quantity_value"
                  />
                </span>
              </div>
            </div>
          </div>

          <div class="coc mt-4" *ngIf="(window.location.pathname !=='/catalogue')">
            <div class="row">
              <div class="col-9">
                <button type="submit" style="padding: 10px;" class="btn_select" [disabled]="!width_value || !height_value || !quantity_value" (click)="addProductToBoqs()">Select Product</button>
              </div>
            </div>
          </div>

          <!-- <div class="prices" price-chng="">
                      <p> ₹ {{product_detail.sale_price | number : '1.2-2'}}</p>
                    </div> -->
        </div>

        <!-- <div
          class="form-possi"
          *ngIf="variation.length > 0"
          style="display: flex; flex-wrap: wrap"
        >
          <div
            style="
              height: 2rem;
              width: 2rem;
              margin: 10px;
              background-color: aquamarine;
            "
            class="variation-img-container rounded-circle variation-img-container-{{
              varia.id
            }} {{ i == 0 ? 'active' : '' }}"
            *ngFor="let varia of variation; let i = index"
          >
          
            <span style="cursor: pointer" (click)="selectVariation(varia.id)">{{
              varia.id
            }}</span>
          </div>
        </div> -->
        <!-- <small class="View-More float-right cursor-pointer" *ngIf="variation.length > 14"
                    (click)="viewMoreVariation($event)">View More</small> -->
        <!-- <div class="form-group" style="clear: both;">
                    <label>Quantity : </label>
                    <input class="form-control ml-3" type="number" style="width: 30%; display: inline-block;" value="1"
                      min="1"
                      (change)="this.modalQuantityandProductSelectionForm.patchValue({productQty: $event.target.value});">
                  </div> -->
        <!-- <div class="form-group">
                    <button class="interalBtnColor cartBtn addCursor mt-2 mb-2"
                      (click)="addProductToBoqs(product_detail,modalQuantityandProductSelectionForm.value)">Select
                      Product</button>
                  </div> -->

        <!-- {{modalQuantityandProductSelectionForm.value | json}} -->
      </div>
      <div class="container mt-4">
	<div class="row">
		<div class="col-md-12">
			<h6 class="PRODUCT-INFORMATION">PRODUCT INFORMATION</h6>
            <table>
               <tr class="trmarg " *ngIf="product_detail.color_text">
                  <td class="text-deco w-60">Color:</td>
                  <td class="text-deco1">{{product_detail.color_text}}</td>
                </tr>
                <tr class="trmarg" *ngIf="product_detail.configuration">
                    <td class="text-deco w-50">Configuration:</td>
                    <td class="text-deco1">{{product_detail.configuration}}</td>
                </tr>
                <tr class="trmarg" *ngIf="product_detail.measurement_unit">
                    <td class="text-deco w-50">Measurment Unit:</td>
                    <td class="text-deco1">{{product_detail.measurement_unit}}</td>
                </tr>
                <tr class="trmarg" *ngIf="product_detail.lead_time_days">
                    <td class="text-deco w-50">Lead time:</td>
                    <td class="text-deco1">{{product_detail.lead_time_days}}</td>
                </tr>
                 <tr class="trmarg" *ngIf="product_detail.finish">
                    <td class="text-deco w-50">Finish</td>
                    <td class="text-deco1">{{product_detail.finish}}</td>
                </tr>
                 <tr class="trmarg" *ngIf="product_detail.length">
                    <td class="text-deco w-50">Dimension(mm):</td>
                    <td class="text-deco1">{{product_detail.length}}<span>&#215;</span>{{product_detail.width}}<span>&#215;</span>{{product_detail.height}}</td>
                </tr>
            </table>
		</div><br>
		<div class="col-md-12 mt-4" *ngIf="product_detail.material">
		    <p class="lorem-head">Material:</p>
            <p class="Lorem-ipsum"> {{product_detail.material}}</p>
        </div>
        <!-- <div class="col-md-12 mt-1" *ngIf="product_detail.dimension_remark">
		    <p class="lorem-head">Dimension Remark:</p>
            <p class="Lorem-ipsum"> {{product_detail.dimension_remark}}</p>
        </div> -->
        <!-- <div class="col-md-12 mt-1" *ngIf="product_detail.remark">
		    <p class="lorem-head">Remark:</p>
            <p class="Lorem-ipsum"> {{product_detail.remark}}</p>
        </div> -->
        <div class="col-md-12 mt-1" *ngIf="product_detail.warranty_text">
		    <p class="WARRANTY"> WARRANTY:</p>
            <p class="Lorem-ipsum">  {{product_detail.warranty_text}}</p>
        </div>
        <!-- <div class="col-md-12 mt-1" *ngIf="product_detail.similar_products.length > 0">
        	 <h6 class="VIEW-SIMILAR-PRODUCT mt-4">VIEW SIMILAR PRODUCT</h6>
        </div> -->

    </div>
 </div>
    </div>
  </section>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/quotation/curtain-details/curtain-details.component.html